import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-flex tw-flex-row" }

import LinkedSelectorLines from 'frontcore/presentation/remote-filters/views/LinkedSelectorLines.vue'
import RemoteFiltersItem from 'frontcore/presentation/remote-filters/views/RemoteFiltersItem.vue'
import { ComputedRef } from 'vue'
import { RemoteFiltersConfiguration } from 'frontcore/presentation/remote-filters/domain/types'

type Props = {
  configuration: RemoteFiltersConfiguration,
  filterStoreID: string,
  moduleRemoteFiltersConfigurations: ComputedRef<RemoteFiltersConfiguration[]>
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RelatedRemoteFiltersItem',
  props: {
    configuration: {},
    filterStoreID: {},
    moduleRemoteFiltersConfigurations: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LinkedSelectorLines, { class: "pl-2" }),
    _createVNode(RemoteFiltersItem, {
      class: "tw-w-full",
      configuration: _ctx.configuration,
      filterStoreID: _ctx.filterStoreID,
      moduleRemoteFiltersConfigurations: _ctx.moduleRemoteFiltersConfigurations
    }, null, 8, ["configuration", "filterStoreID", "moduleRemoteFiltersConfigurations"])
  ]))
}
}

})